import React, { Component } from 'react';
import { formatAmount } from 'src/Common/utils';

export default class Payments extends Component {
    render() {
        const { title, description, amount } = this.props;
        return (
            <tr>
                <td>{title}</td>
                <td>{description}</td>
                <td>{formatAmount(amount)}</td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Items/TableRow.js